import { Amount } from '@mews-commander/types';
import { Stack } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { getPositiveAmount } from '@mews-commander/utils';
import { InlineAmountDue } from '../AmountDue';

interface Props {
    amount: Amount;
}

const InlineBalance: React.FC<Props> = ({ amount }) => {
    const { value } = amount;

    const isAmountNegative = value < 0;
    const positiveAmount = getPositiveAmount(amount);
    const labelText = isAmountNegative ? TextKey.ToBeRefunded : TextKey.ToBePaid;

    return (
        <Stack inline spacing="50">
            <LocalizedText textKey={labelText} />
            <InlineAmountDue isNegative={isAmountNegative} value={positiveAmount} />
        </Stack>
    );
};

export default InlineBalance;
